<!--
 * @Description: 
 * @Author: zml
 * @Date: 2025-03-11 10:46:43
 * @LastEditors: zml
 * @LastEditTime: 2026-07-16 16:42:29
-->
<template>
  <div class="logo-box">
    <div class="logo-navBar container">
      <div class="logo-navBar-left">
        <ul>
          <li @click="goLogin">
            <span style="margin-right: 10px;">{{ userInfo.id ? $hs('退出登录','Log out','Salir del login'):$hs('登录','Sign In','inicio')}}</span>
            <el-divider direction="vertical"></el-divider>
          </li>
          <li>
            <span style="margin-right: 10px;" @click="goCart">{{ $hs('我的订单','My Order','Mi pedido') }}</span>
            <el-divider direction="vertical"></el-divider>
          </li>
          <!-- <li @click="commandMenu">
            <span>{{$hs('Chinese','español','English')}}</span>
          </li>-->
          <li>
            <el-dropdown trigger="click" @command="commandMenu">
              <span style="color: #dedede;">
                {{ LanguageType }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="items.language" v-for="(items,index) in languageListcp" :key="index">{{ items.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <div class="logo-navBar-right">
        <ul>
          <li>
            <img src="../../assets/LLH_follow/email.png" alt style="width: 42px;height: 42px;margin-right: 12px;" />
            <a href="mailto:viptoys@viptoys.com" style="color:#dedede; text-decoration: none;">viptoys@viptoys.com</a>
          </li>
          <li>
            <img src="../../assets/LLH_follow/phone.png" alt style="width: 42px;height: 42px;margin-right: 12px;" />
            <span>+86 13049982278</span>
          </li>
        </ul>
      </div>
    </div>
    <login-modal ref="loginModal" @register="register" @forgetpassword="forgetpassword"></login-modal>
    <register-model ref="registerModel" @login="login"></register-model>
    <reset-pass-model ref="resetPassModel" @login="login"></reset-pass-model>
    <update-info ref="updateInfo"></update-info>
  </div>
</template>
<script>
import loginModal from '@/components/memberModal/loginModal.vue'
import registerModel from '@/components/memberModal/registerModel.vue'
import resetPassModel from '@/components/memberModal/resetPassModel.vue'
import updateInfo from '@/components/memberModal/updateInfo.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { setDocumentTitle } from '@/utils/domUtil'
export default {
  name: 'logoBox',
  components: {
    loginModal,
    registerModel,
    updateInfo,
    resetPassModel
  },
  data() {
    return {
      languagelcaList: [{ language: "zh-Hans", name: "中文(Chinese)" }, { language: "en", name: "English" }, { language: "es", name: "español" }],
      keywords: '',
      LanguageType: this.$i18n.locale == 'es' ? 'español' : this.$i18n.locale == 'en' ? 'English' : '中文(Chinese)'
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters('setting', {
      getSetting: 'get_setting',
      getLanguageConfig: 'get_language_config'
    }),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),
    languageListcp() {
      let list = this.getLanguageConfig.languageList ? this.getLanguageConfig.languageList : []
      let newlist = this.languagelcaList.filter(op => list.includes(op.language));
      return newlist
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('user', ['logout']),
    ...mapActions('operate', {
      set_language: 'set_language'
    }),
    // 登录
    login() {
      this.$refs.loginModal.open()
    },

    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    // 打开忘记密码
    forgetpassword() {
      this.$refs.resetPassModel.open()
    },
    // 更新信息
    updateInfo() {
      this.$refs.updateInfo.open()
    },

    // 跳转我的订单
    linkOrder() {
      if (Object.keys(this.userInfo).length > 0) {
        this.$router.push({ path: '/order' })
      } else {
        this.login()
      }
    },

    // 登录
    goLogin() {
      this.getScrollTop();
      if (Object.keys(this.userInfo).length > 0) {
        // this.updateInfo()
        this.$confirm(this.$hs('是否退出登录?', 'Log out?', '¿Cerrar sesión?'), this.$hs('退出登录', 'Log out', 'Cerrar la sesión'), {
          confirmButtonText: this.$hs('确定', 'Confirm', 'Confirmar confirmación'),
          cancelButtonText: this.$hs('取消', 'Cancel', 'cancelar'),
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('Token')
          localStorage.removeItem('userInfo')
          location.reload()
          this.$router.push('/home')
        }).catch(() => {
        });
      } else {
        this.login()
      }
    },
    getScrollTop() {
      localStorage.setItem('scrollTop', JSON.stringify(0))
    },
    // 跳转购物车
    goCart() {
      this.getScrollTop();
      if (Object.keys(this.userInfo).length > 0) {
        this.$router.push({ path: '/order' })
      } else {
        this.login()
      }
    },

    // 搜索
    onSearch() {
      if (this.$route.path !== '/product') {
        this.$router.push({
          name: 'product',
          params: { keywords: this.keywords }
        })
      }
      this.$bus.$emit('searchProduct', this.keywords)
    },

    // 高级搜索
    onAdvancedSearch() {
      this.$router.push('/home')
      this.$nextTick(() => {
        document.querySelector('#advanced-search').scrollIntoView(true)
      })
    },
    commandMenu(command) {
      if (command == 'es') {
        this.LanguageType = 'español'
        this.$i18n.locale = 'es'
        this.set_language('es')
        setDocumentTitle(this.getSetting.title)
      }
      if (command == 'en') {
        this.LanguageType = 'English'
        this.$i18n.locale = 'en'
        this.set_language('en')
        setDocumentTitle(this.getSetting.enTitle)
      }
      if (command == 'zh-Hans') {
        this.LanguageType = '中文(Chinese)'
        this.$i18n.locale = 'zh'
        this.set_language('zh')
        setDocumentTitle(this.getSetting.enTitle)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dropdown-menu__item:hover {
  background-color: #490d59;
  color: #fff;
}
.logo-box {
  width: 100%;
  background-color: #490d59;
  position: fixed;
  top: 0;
  z-index: 999;
  height: 62px;
  .logo-navBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
    ul {
      display: flex;
      align-items: flex-start;
      margin-top: 9px;
      list-style: none;
    }
    ul li {
      color: #dedede;
      display: flex;
      align-items: center;
      margin-right: 20px;
      span {
        cursor: pointer;
      }
    }
  }
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>